import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiEndpoints } from '../../constants/api-endpoints.config';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private apiEndPoint: any = ApiEndpoints;
  url: string = environment.apiurls.baseUrl;

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) { }

  /**
   * Get dashboard statistics
   * @returns Observable with dashboard stats
   */
  getDashboardStats(): Observable<any> {
    return this.apiService.get(`${this.url}${this.apiEndPoint.dashboard.getStats}`);
  }

  /**
   * Download user report
   * @returns Observable for file download
   */
  downloadUserReport(): Observable<Blob> {
    const token = this.localStorageService.getAuthToken();
    const headers = new HttpHeaders({
      'x-access-token': token || '',
    });

    return this.http.get(`${this.url}${this.apiEndPoint.dashboard.downloadUserReport}`, {
      headers: headers,
      responseType: 'blob'
    });
  }

  /**
   * Get video session counts with filter
   * @param filter - Filter type: '7days', '4weeks', '12months'
   * @returns Observable with video session counts data
   */
  getVideoSessionCounts(filter: string): Observable<any> {
    return this.apiService.get(`${this.url}${this.apiEndPoint.dashboard.videoSessionCounts}?filter=${filter}`);
  }
}
